import React, { useEffect, useRef } from 'react';
import { SvgIcon } from './SvgIcon';
import { getTranslation } from '../utils/translations';
import PropTypes from 'prop-types';

export const PlayerSearchInput = ({
    setDebouncedQuery,
    isActive,
    onClick,
    query
}) => {
    useEffect(() => {
        if (isActive) {
            if (query) {
                inputRef.current.value = query;
            }
        }
    }, [isActive]);

    const inputRef = useRef(null);

    return (
        <div
            className={
                'player-search__input-wrap ' + (isActive ? 'is-active' : '')
            }
        >
            <div className="player-search__input-wrap-inner">
                <label
                    htmlFor="statsPlayerSearch"
                    className="player-search__label"
                >
                    <span className="u-screen-reader">
                        {getTranslation(
                            'label.brownlow.predictor.searchPlayers'
                        )}
                    </span>
                    <SvgIcon
                        icon={`search`}
                        className={`player-search__icon`}
                    />
                </label>
                <input
                    className="player-search__input"
                    type="search"
                    autoComplete="off"
                    placeholder={getTranslation(
                        'label.brownlow.predictor.searchPlayers'
                    )}
                    id="statsPlayerSearch"
                    onChange={(event) => setDebouncedQuery(event.target.value)}
                    ref={inputRef}
                />
            </div>

            <button onClick={onClick} className="player-search__cancel">
                {getTranslation('label.button.cancel')}
            </button>
        </div>
    );
};

PlayerSearchInput.propTypes = {
    setDebouncedQuery: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    query: PropTypes.string
};
